import React from 'react';
import { motion } from 'framer-motion';
import { ScanLine, Brain, ShieldAlert, AlertTriangle, ImagePlus, Heart } from 'lucide-react';
export function Features() {
  const features = [{
    title: 'Instant Scanning',
    description: 'Scan ingredient labels in seconds with your camera. Fast and accurate text recognition.',
    icon: ScanLine,
    color: 'text-blue-500',
    bg: 'bg-blue-50'
  }, {
    title: 'AI-Powered Analysis',
    description: 'Advanced AI identifies harmful and questionable ingredients from our vast database.',
    icon: Brain,
    color: 'text-purple-500',
    bg: 'bg-purple-50'
  }, {
    title: 'Ingredients to Avoid',
    description: 'Clear warnings for ingredients linked to health concerns like inflammation or allergies.',
    icon: ShieldAlert,
    color: 'text-red-500',
    bg: 'bg-red-50'
  }, {
    title: 'Limited Intake Alerts',
    description: 'Know which ingredients should be consumed in moderation, like high sugar or sodium.',
    icon: AlertTriangle,
    color: 'text-accent-500',
    bg: 'bg-accent-50'
  }, {
    title: 'Photo Upload',
    description: 'Upload existing photos of ingredient labels from your gallery for analysis.',
    icon: ImagePlus,
    color: 'text-teal-500',
    bg: 'bg-teal-50'
  }, {
    title: 'Free Ingredient Scanner',
    description: 'Scan and detect ingredients for free. Customization options available at minimum cost.',
    icon: Heart,
    color: 'text-brand-500',
    bg: 'bg-brand-50'
  }];
  return <section id="features" className="py-20 bg-brand-50/30" data-id="element-1327" data-mp="3qkorxr635rc3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1328" data-mp="3lkkfcc8atgr5">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1329" data-mp="3dmr9iqmfmpa">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-1330" data-mp="3e62kglrncuc">
            Why IntelliEats?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-1331" data-mp="2s6rp29klh4am">
            Everything you need to make smarter food choices, right in your
            pocket.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1332" data-mp="2x6496mk2zx9i">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 group" data-id="element-1333" data-mp="315muvkjq8cde" data-mpi={index}>
              <div className={`w-12 h-12 rounded-xl ${feature.bg} ${feature.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-1334" data-mp="1qj8psfqk80j7">
                <feature.icon className="w-6 h-6" data-id="element-1335" data-mp="1n1l2mygh9sh0" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1336" data-mp="1i803h335esg8">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-1337" data-mp="1d7m3877sgmsr">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}